'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global document */


/*
  Youtube player states:
    UNSTARTED = -1;
    ENDED = 0;
    PLAYING = 1;
    PAUSED = 2;
    BUFFERING = 3;
    CUED = 5;
*/

var IS_ENDED = 0;
var IS_PLAYING = 1;
var IS_PAUSED = 2;
var IS_BUFFERING = 3;

var Youtube = function (_React$Component) {
  _inherits(Youtube, _React$Component);

  function Youtube(props) {
    _classCallCheck(this, Youtube);

    var _this = _possibleConstructorReturn(this, (Youtube.__proto__ || Object.getPrototypeOf(Youtube)).call(this, props));

    _this.state = {
      isAutoplay: true,
      playerState: -1,
      pauseByScroll: undefined,
      isPlayer: undefined
    };

    _this.iframeRef = undefined;
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.screenChange = _this.screenChange.bind(_this);
    _this.sentMsgtoYoutube = _this.sentMsgtoYoutube.bind(_this);
    _this.onPlayerReady = _this.onPlayerReady.bind(_this);
    _this.onMessageReceived = _this.onMessageReceived.bind(_this);
    return _this;
  }

  _createClass(Youtube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      document.addEventListener('fullscreenchange', this.screenChange);
      document.addEventListener('webkitfullscreenchange', this.screenChange);
      document.addEventListener('mozfullscreenchange', this.screenChange);
      document.addEventListener('MSFullscreenChange', this.screenChange);

      this.iframeRef.addEventListener('load', this.onPlayerReady);

      // NOTE: addEventListener will fail in Chrome if this component is not
      // in the screen when the page is loaded. This will cause onMessageReceived
      // method not invoked when the user play or pause the Youtube video.
      window.addEventListener('message', this.onMessageReceived);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      document.removeEventListener('fullscreenchange', this.screenChange);
      document.removeEventListener('webkitfullscreenchange', this.screenChange);
      document.removeEventListener('mozfullscreenchange', this.screenChange);
      document.removeEventListener('MSFullscreenChange', this.screenChange);
      window.removeEventListener('message', this.onMessageReceived);
    }
  }, {
    key: 'onMessageReceived',
    value: function onMessageReceived(event) {
      if (event.origin !== 'https://www.youtube-nocookie.com') {
        return false;
      }

      var data = JSON.parse(event.data);
      if (!data.info) return false;

      var playerState = data.info.playerState;

      if (!playerState) return false;

      // user manually clicked the Play button(autoplay disabled)
      if (parseInt(this.props.autoplay, 10) === 0 && playerState === IS_BUFFERING) {
        this.setState({ isAutoplay: false });
      }

      switch (playerState) {
        case IS_PLAYING:
          this.setState({
            playerState: IS_PLAYING,
            pauseBy: 0
          });
          break;

        case IS_PAUSED:
          if (!this.state.pauseByScroll) {
            this.setState({
              playerState: IS_PAUSED,
              pauseByScroll: false,
              pauseBy: 1
            });
          } else {
            this.setState({
              playerState: IS_PAUSED,
              pauseByScroll: false
            });
          }
          break;

        case IS_ENDED:
          this.setState({
            playerState: IS_ENDED,
            pauseBy: 1
          });
          break;
        default:
          break;
      }

      return true;
    }
  }, {
    key: 'onPlayerReady',
    value: function onPlayerReady(event) {
      var func = '{"event": "listening"}';

      this.iframeRef.contentWindow.postMessage(func, 'https://www.youtube-nocookie.com');

      this.setState({
        pauseBy: 0,
        pauseByScroll: false,
        isPlayer: event.target
      });

      this.sentMsgtoYoutube('stopVideo');
      this.handleScroll();
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.state.isPlayer) return;

      // this check allows the video to keep playing even if its out of the viewport
      // based on state.isAutoplay: true & props.autoplay: 0
      if (this.state.isAutoplay && parseInt(this.props.autoplay, 10) === 0) return;

      var height = window.innerHeight;
      var videoRect = this.iframeRef.getBoundingClientRect();
      var playRect = videoRect.top + videoRect.height / 2;

      if (playRect < 0 || playRect > height) {
        if (this.state.pauseBy === 0 && this.state.playerState !== 2 && this.state.playerState !== -1) {
          this.setState({ pauseByScroll: true });
          this.sentMsgtoYoutube('pauseVideo');
        }
      } else if (this.state.pauseBy !== 1) {
        // when video is scrolled back to the screen,
        // if the video is not paused by the user, then continue playing the video
        // otherwise keep it paused for a better user experience
        this.sentMsgtoYoutube('playVideo');
        this.sentMsgtoYoutube('mute');
      }
    }
  }, {
    key: 'sentMsgtoYoutube',
    value: function sentMsgtoYoutube(func, args) {
      this.iframeRef.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: func,
        args: args || []
      }), 'https://www.youtube-nocookie.com');
    }
  }, {
    key: 'screenChange',
    value: function screenChange() {
      if (!!document.fullScreenElement || !!document.msFullscreenElement || !!document.webkitFullscreenElement || !!document.mozFullScreenElement) {
        this.sentMsgtoYoutube('unMute');
      } else {
        this.sentMsgtoYoutube('mute');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoplay = _props.autoplay,
          className = _props.className,
          videoId = _props.videoId,
          height = _props.height,
          width = _props.width;


      return _react2.default.createElement(
        'div',
        { className: className + '__video' },
        _react2.default.createElement(
          'div',
          { className: className + '__video-wrapper' },
          _react2.default.createElement('iframe', {
            ref: function ref(c) {
              _this2.iframeRef = c;
            },
            className: className + '__video-wrapper__iframe',
            frameBorder: '0',
            allowFullScreen: '1',
            sandbox: 'allow-scripts allow-same-origin',
            title: 'YouTube video player',
            width: width,
            height: height,
            src: 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=' + autoplay + '&amp;rel=0&amp;autohide=2&amp;border=0&amp;wmode=opaque&amp;showinfo=0&amp;hd=1&amp;playsinline=1&amp;enablejsapi=1&amp;modestbranding=1&amp;mute=1'
          })
        )
      );
    }
  }]);

  return Youtube;
}(_react2.default.Component);

exports.default = Youtube;


Youtube.defaultProps = {
  autoplay: 1,
  width: 515,
  height: 290,
  className: ''
};

Youtube.propTypes = {
  autoplay: _propTypes2.default.oneOf([1, 0]),
  className: _propTypes2.default.string,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  videoId: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/youtube/jsx/Youtube.js
// module id = 569
// module chunks = 4